import React from 'react';
import { motion } from 'framer-motion';
import { MapIcon } from 'lucide-react';
import { party, travelNotes } from '../data/party';
export function KnowBeforeYouGo() {
  return <section id="travel" className="w-full bg-[var(--sand)] px-5 py-24" data-id="element-46" data-mp="1bevldy0z6lg8">
      <div className="mx-auto max-w-4xl" data-id="element-47" data-mp="1bgq5xb8c4bjs">
        <h2 className="font-display mb-12 text-center text-5xl uppercase text-[var(--terracotta)] sm:text-6xl" data-id="element-48" data-mp="1gdztsmg2sf5i">
          Know Before You Go
        </h2>

        <dl className="grid gap-5 sm:grid-cols-2" data-id="element-49" data-mp="is2jvdfrhi56">
          {travelNotes.map((note, i) => <motion.div key={note.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-3xl border border-[var(--terracotta)]/10 bg-[var(--cream)] p-7 shadow-sm" data-id="element-50" data-mp="nr5c1xan7tvq" data-mpi={i}>
              <dt className="font-poster mb-2 text-xl uppercase tracking-wide text-[var(--night)]" data-id="element-51" data-mp="283l6rybt9w6y">
                {note.title}
              </dt>
              <dd className="leading-relaxed text-[var(--dusk)]" data-id="element-52" data-mp="3s7f9fg9rjbzv">{note.detail}</dd>
            </motion.div>)}
        </dl>

        <div className="mt-10 text-center" data-id="element-53" data-mp="3n7asxq8uuh9n">
          <a href={party.estateMapUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[var(--terracotta)] px-7 py-3 font-poster text-lg uppercase tracking-[0.12em] text-[var(--cream)] transition-colors hover:bg-[var(--sunset)] focus:outline-none focus:ring-2 focus:ring-[var(--terracotta)] focus:ring-offset-2 focus:ring-offset-[var(--sand)]" data-id="element-54" data-mp="3naf457kqmd9t">
            <MapIcon className="h-5 w-5" data-id="element-55" data-mp="2zjj63spoulu4" />
            View the Parker Estate Map
          </a>
        </div>
      </div>
    </section>;
}